import React from "react";
import VoiceImage from "../VoiceImage";
import Link from "next/link";
import { MdAutoFixHigh } from "react-icons/md";
import { FaHeart, FaLock } from "react-icons/fa";
import { PiMicrophoneStageFill } from "react-icons/pi";

const ModelCollectionItem = ({ collection, idx }) => {
  return (
    <Link
      style={{
        animationDelay: `${0.05 * idx}s`,
      }}
      href={`/collection/${collection._id}`}
      className="card-fade-in tw-opacity-0 tw-w-full tw-relative tw-min-w-64 tw-max-w-sm  tw-cursor-pointer  tw-relative tw-flex tw-items-center tw-justify-center"
    >
      <div className="tw-absolute tw-z-[5]  tw--bottom-2  tw-w-11/12 tw-h-full tw-bg-gray-200/70 tw-rounded-3xl" />
      <div className="tw-absolute  tw-z-[2] tw--bottom-4  tw-w-10/12 tw-h-full tw-bg-gray-100 tw-rounded-3xl" />

      <div
        key={collection._id}
        className="tw-w-full tw-h-40 tw-flex tw-flex-col tw-justify-end tw-p-4 tw-bg-gray-100 tw-rounded-3xl tw-relative"
      >
        <VoiceImage
          model={{ image: collection.image }}
          fill
          className="tw-absolute tw-z-10 tw-top-0 tw-left-0 tw-object-cover tw-w-full tw-h-full tw-rounded-3xl "
        />
        <div className="tw-absolute tw-z-20 tw-bottom-0 tw-left-0 tw-w-full tw-h-full tw-bg-gradient-to-t tw-from-black/90 tw-to-transparent tw-rounded-b-3xl" />
        <div className="tw-font-bold tw-flex tw-flex-col tw-h-full tw-text-white tw-text-xl tw-w-full tw-z-30">
          <div className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-justify-between">
            <div className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-font-black tw-bg-black/60 tw-w-max tw-p-1 tw-rounded-full tw-px-2">
              <span>{collection.likes}</span>
              <FaHeart size={12} className="tw-text-red-500" />
            </div>
            <div className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-font-black tw-bg-black/60 tw-w-max tw-p-1 tw-rounded-full tw-px-2">
              <span>{collection.modelsCount}</span>
              <PiMicrophoneStageFill size={14} />
            </div>
          </div>
          <div className="tw-text-white tw-text-xl tw-w-full tw-font-black tw-mt-auto">
            {collection.title}
          </div>
          {collection.autoGeneratedId ? (
            <div className="tw-text-xs tw-bg-green-50/50 tw-rounded-full tw-font-bold tw-text-sm tw-flex tw-items-center tw-gap-2 tw-p-1 tw-px-2  tw-w-max">
              <MdAutoFixHigh size={18} />
              <span>Auto Generated Collection</span>
            </div>
          ) : (
            <div className="tw-text-white tw-text-sm tw-w-full">
              By {collection.user?.username}
            </div>
          )}
        </div>
        {collection.isPrivate === true && (
          <div className="tw-flex tw-rounded-full tw-itms-center tw-gap-1 tw-absolute tw-bottom-2 tw-right-2 tw-z-50 tw-bg-gray-200/60 tw-py-1.5 tw-px-3 tw-text-black tw-text-xs tw-tracking-widest tw-font-black">
            <FaLock />
            PRIVATE
          </div>
        )}
      </div>
    </Link>
  );
};

export default ModelCollectionItem;
